import React from 'react';
import { observer } from 'mobx-react-lite';
import { PendingEditManagerVM } from 'cd-eft/components/common/PendingEditManager/PendingEditManagerVM';
import './PendingEditManager.scss';
import { MeasureToolboxView } from 'cd-eft/components/common/MeasureTools/MeasureToolboxView';
import { DrawingToolboxView } from 'cd-eft/components/common/DrawingTools/view/DrawingToolboxView';
import { MapView } from 'cd-eft/utils/esriTypes';

// Design
import { mdiClose, mdiHammerWrench, mdiContentSave } from '@mdi/js';
import Icon from '@mdi/react';
import { ToolSlot } from 'cd-eft/components/Design/BreaklineTools/framework/Tool';
interface IPendingEditManagerComponentProps {
  vm: PendingEditManagerVM;
  toolSlot?: ToolSlot;
  activeTab: string;
  mapView: MapView;
}

function PendingEditManagerComponent(props: IPendingEditManagerComponentProps) {
  const vm = props.vm;

  return (
    <>
      {/* popups  */}
      {/*       {(props.designElementTypeId !== appConfig.hardCodes.designElementTypeSuface && vm.drawings.pendingEditCount > 0) && (
        <UserLeavingWarning
          when={vm.drawings.pendingEditCount > 0}
          section={vm.drawingsGroupLayerByDesignElementType[props.designElementTypeId].title}
          onOK={vm.userLeavingUncommitedEditsWarningOnOk}
          okText="Return"
          text={
            (vm.drawings.pendingEditCount > 0) ? (MessageCenter.getFromCache('Common_15') + vm.drawingsGroupLayerByDesignElementType[props.designElementTypeId].title) : ''
          }
        />
      )} */}

      {/* {props.designElementTypeId && ( */}
      <div className="hydrology-tool-container">
        {/* Toolbar button */}
        <button className="esri-widget--button toolbar-btn " aria-label="close tool"
          onClick={vm.openToolBar}
        >
          <Icon path={mdiHammerWrench} title="Toolbar" size={0.8} className="esri-collapse__icon esri-icon-public" />
        </button>

        {!vm.hideToolbar && (
          <div className="hydrology-toolbar">
            {/* Toolbar panel */}

            {/* Toolbar panel tabs */}
            <div className="hydrology-toolbar-tab">
              <button
                className={`esri-icon-measure ${vm.activeTab === 'Measure' ? 'active' : ''}`}
                aria-label="measure tool"
                title="Measure"
                onClick={vm.onClickMeasureTool}
              ></button>
              <button
                className={`esri-icon-authorize ${vm.activeTab === 'Drawing' ? 'active' : ''}`}
                aria-label="drawing tool"
                title="Drawing"
                onClick={vm.onClickDrawingTool}
              ></button>
              <button className="hydrology-toolbar-tab-close" aria-label="close tool" onClick={() => vm.closeToolBar(0, 'dem')}>
                <Icon path={mdiClose} title="Close" size={1} />
              </button>
            </div>

            {/* Toolbar panel body */}
            <div className="hydrology-toolbar-body p-3">
              {vm.activeTab === 'Drawing' ? (
                <div>
                  <h5>Drawing</h5>
                  <DrawingToolboxView drawingTools={vm.drawingTools} />
                </div>
              ) : null}
              {vm.activeTab === 'Measure' ? (
                <div>
                  <h5>Measure</h5>
                  {vm.inputManager !== undefined && (
                    <MeasureToolboxView
                      inputManager={vm.inputManager}
                      measureResults={vm.measureResults}
                      onChangeMeasureTool={vm.onChangeMeasureTool}
                      selectedMeasurementUnits={{
                        distance: vm.measureDistanceUnits,
                        area: vm.measureAreaUnits,
                        perimeter: vm.measurePerimeterUnits,
                      }}
                    ></MeasureToolboxView>
                  )}
                  {/* To show 'Distance Unit' dropdown list */}
                  {vm.measureToolType === 'measure-distance' ? (
                    <div className="select-dropdown">
                      <select
                        className="usa-select"
                        id="measure_distance_units"
                        aria-label="measure_distance_units"
                        name="measure_distance_units"
                        value={vm.measureDistanceUnits}
                        onChange={vm.onChangeDistanceUnits}
                      >
                        {/* <option value="feet">Distance Unit</option> */}
                        <option value="feet">Feet</option>
                        <option value="meters">Meters</option>
                        <option value="miles">Miles</option>
                        <option value="kilometers">Kilometers</option>
                      </select>
                    </div>
                  ) : null}
                  {/* To show 'Area/Perimeter Unit' dropdown list */}
                  {vm.measureToolType === 'measure-area' ? (
                    <div className="select-dropdown">
                      <select
                        className="usa-select"
                        id="measure_area_units"
                        aria-label="measure_area_units"
                        name="measure_area_units"
                        value={vm.measureAreaUnits + '/' + vm.measurePerimeterUnits}
                        onChange={vm.onChangeAreaPerimeterUnits}
                      >
                        {/* <option value="acres/feet">Area/Perimeter Unit</option> */}
                        <option value="square-kilometers/kilometer">Sq. Kilometers / Kilometer</option>
                        <option value="acres/feet">Acres / Feet</option>
                        <option value="hectares/meters">Hectares / Meters</option>
                        <option value="square-miles/miles">Sq. Miles / Miles</option>
                      </select>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
            {/* Toolbar footer */}
            <div className="hydrology-toolbar-footer p-3">
              {/*  <h5>Pending edits count: {vm.uncommittedEdits} </h5> */}
              <h5>Pending edits count: {vm.drawings ? vm.drawings.pendingEditCount : 0} </h5>
              <div className="hydrology-toolbar-footer-save">
                <button aria-label="Save Pending edits" title="Save" onClick={vm.onSaveStructurePendingEdits}>
                  <Icon path={mdiContentSave} title="Save" size={1} className="hydrology-toolbar-footer-save-icon" /> Save
                  Changes
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {/*  )} */}
    </>
  );
}

export const PendingEditManager = observer(PendingEditManagerComponent);
